import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MaterialPalette } from '@nutrien/cxp-components';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      height: 'calc(100vh - 219px)',
      overflowY: 'auto',
    },
    root1: {
      height: 'calc(100vh - 269px)',
      overflowY: 'auto',
    },
    xFeatherGrid: {
      alignSelf: 'center',
      marginLeft: '16px',
      display: 'flex',
    },
    searchBarOuterGrid: {
      alignSelf: 'center',
      display: 'flex',
    },
    quickFilterText: {
      display: 'inline-block',
      textAlign: 'right',
    },
    dividerGrid: {
      marginLeft: 16,
      marginRight: 16,
      alignSelf: 'center',
      height: 32,
    },
    ViewInspector: {
      cursor: 'pointer',
      letterSpacing: '0.1px',
      width: 'fit-content',
    },
    addViewInspectorLabel: {
      '& > p': {
        fontSize: '14px',
        fontWeight: '600',
      },
    },
    signStampButtonGrid: {
      '& > div > button': {
        width: 'fit-content',
        height: '32px',
      },
    },
    signStampButton: {
      letterSpacing: '1.25px',
    },
    searchTextField: {
      padding: '0px',
      cursor: 'pointer',
    },
    workpackagesListContainer: {
      padding: 16,
      cursor: 'pointer',
    },
    workpackageCard: {
      padding: '8px',
    },
    txtBgColor: {
      backgroundColor: '#121212',
    },
    searchTextDiv: {
      backgroundColor: '#121212',
    },
    emptyWorkpackagesContainer: {
      textAlign: 'center',
    },
    pageTitle: {
      fontSize: 25,
      fontWeight: 300,
      maxWidth: '330px',
    },
    searchContainer: {
      alignSelf: 'center',
      '& > div > div > div': {
        width: '215px',
      },
    },
    quickFilterGrid: {
      alignSelf: 'center',
    },
    inProgressButGrid: {
      marginLeft: 8,
      alignSelf: 'center',
      '& button': {
        borderRadius: '27px',
        height: 32,
      },
      '& .inProgressBut': {
        color: MaterialPalette.common.white,
        backgroundColor: '',
      },
      '& .notInProgressBut': {
        color: '#6CD9C7',
        backgroundColor: 'rgba(39, 126, 126, 0.19)',
      },
    },
    assignedButGrid: {
      marginLeft: 8,
      alignSelf: 'center',
      '& button': {
        borderRadius: '27px',
        height: 32,
      },
      '& .assignedBut': {
        color: MaterialPalette.common.white,
      },
      '& .notAssignedBut': {
        color: '#6CD9C7',
        backgroundColor: 'rgba(39, 126, 126, 0.19)',
      },
    },
    statusGrid: {
      flexDirection: 'row',
      '& .statusCompletedText': {
        color: 'rgba(33, 110, 165, 1)',
        whiteSpace: 'pre',
      },
      '& .statusNotCompletedText': {
        color: '',
        whiteSpace: 'pre',
        position: 'relative',
        top: 8,
      },
    },
    dividerBg: {
      backgroundColor: 'rgba(255, 255, 255, 0.4)',
    },
    workpackageContainer: {
      '& > div > div ': {
        padding: '12px',
        marginBottom: '0px',
      },
    },
    emptyBox: {
      verticalAlign: 'middle',
      marginRight: '18px',
    },
    messageGrid: {
      padding: '16px',
    },
    divText: {
      display: 'inline-block',
      verticalAlign: 'middle',
    },
    individualStatusGrid: {
      flexDirection: 'column',
      width: 'fit-content',
      paddingRight: 42,
    },
  }),
);

export default useStyles;
